import { RESPONSIVE_PADDING } from 'constants/ui';

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: {
    xs: RESPONSIVE_PADDING.MOBILE,
    sm: RESPONSIVE_PADDING.TABLET,
    md: RESPONSIVE_PADDING.DESKTOP,
  },
};

export const wrapperStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'repeat(1, 1fr)',
    sm: 'repeat(2, 1fr)',
    md: 'repeat(4, 1fr)',
  },
  gap: {
    xs: RESPONSIVE_PADDING.MOBILE,
    sm: RESPONSIVE_PADDING.TABLET,
    md: RESPONSIVE_PADDING.DESKTOP,
  },
};

export const sharedSectionWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '24px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.m,
};
